import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Button } from '@repo/ui';
import { useTranslation } from 'react-i18next';
import noAvailableOffers from '@repo/assets/images/no-available-offers.svg?url';

import { useModalStore } from '@/components/modal/modal.store';

export function NoAvailableOffersModalContent() {
  const { t } = useTranslation();
  const { closeModal } = useModalStore();

  return (
    <Box>
      <Typography component="p" marginBottom={3} textAlign="center" variant="h4" fontWeight="bold">
        {t('selectOfferPage.offerForm.multiprovider.noAvailableOffersModal.title')}
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center" marginBottom={5}>
        <Box component="img" src={noAvailableOffers} />
      </Box>

      <Typography textAlign="center" paddingX={{ xs: 0, lg: 3 }} marginBottom={6}>
        {t('selectOfferPage.offerForm.multiprovider.noAvailableOffersModal.description')}
      </Typography>
      <Box display="flex" justifyContent="center" alignItems="center">
        <Button
          color="info"
          data-testid="select-offer-view-submit-btn"
          size="large"
          variant="contained"
          onClick={closeModal}
        >
          {t('selectOfferPage.offerForm.multiprovider.noAvailableOffersModal.button')}
        </Button>
      </Box>
    </Box>
  );
}
